'use client'
import { type SupabaseClient } from '@supabase/supabase-js'

import { STORAGE_BUCKET_KEY } from '@/constants'
import { decryptImage, getImageAspectRatio } from '@/utils'

export interface GetImageArgs {
  client: SupabaseClient
  image: {
    path: string
    type: string
  }
  encryptionKey: string | undefined
}

const getImage = async ({ client, image, encryptionKey }: GetImageArgs) => {
  const { data, error } = await client.storage
    .from(STORAGE_BUCKET_KEY)
    .download(image.path)
  if (error) throw new Error(`Failed to get files: ${error.message}`)

  if (data.type === 'application/octet-stream') {
    const text = await data.text()
    const decryptedImage = await decryptImage({
      encryptedImage: text,
      type: image.type,
      password: encryptionKey ?? '',
    })
    return decryptedImage
  } else {
    const aspectRatio = await getImageAspectRatio(data)
    const url = URL.createObjectURL(data)
    return { url, aspectRatio }
  }
}

export default getImage
